import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as DatasourceDownstreamOwnersQuery
export const DatasourceDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query DatasourceDownstreamOwnerIdsQuery($datasourceVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  publishedDatasources(filter: { vizportalUrlId: $datasourceVizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
